module.exports = __webpack_public_path__ + "img/7_129.9bb2cdc9.png";